// Sadeleştirilmiş üye kaydı — 3 adım: bilgiler, şifre, ödeme.
//
// Eski form tek sayfada 13 alan + 3 onay kutusu istiyordu. Yeni akışta kayıt
// ekranı ad, soyad, telefon ve şifre soruyor; e-posta, ülke, şehir, cinsiyet,
// doğum tarihi ve kariyer seviyesi ödemeden sonra UYGULAMA İÇİNDE toplanıyor.
// Toplanan veri azalmıyor, sadece daha geç alınıyor. Şifre kayıtta alınıyor ki
// üye ilk girişten itibaren SMS beklemeden şifresiyle girebilsin.
//
// Kayıtta doğrulama kodu YOK (12 Eki 2026): numara uygulamaya ilk girişte
// doğrulanır — Türkiye numarasına SMS, yurt dışı numarasına e-posta kodu.
// Bu yüzden yurt dışı numarasında e-posta kayıtta isteniyor.

import React, { Component } from "react";
import {
  UserPlus, Phone, Mail, ArrowLeft, ArrowRight,
  CheckCircle, AlertCircle, Tag, CreditCard, Smartphone, Lock, Eye, EyeOff,
} from "lucide-react";
import PropTypes from "prop-types";
import UygulamayaGec from "../Components/UygulamayaGec";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import trLabels from "react-phone-number-input/locale/tr.json";

const API = process.env.REACT_APP_API_URL;
const EN_AZ_SIFRE = 6; // sunucudaki kuralla aynı (kayit.js)

// Ortak alan görünümü; sayfanın geri kalanıyla aynı dilde kalsın diye
// mevcut kayıt sayfasının renk ve ölçüleri korundu.
const kutuStili = {
  width: "100%",
  padding: "15px 18px",
  border: "2px solid #e2e8f0",
  borderRadius: "12px",
  fontSize: "15px",
  transition: "border-color 0.2s ease",
  background: "#ffffff",
  boxSizing: "border-box",
};

const etiketStili = {
  display: "block",
  marginBottom: "8px",
  fontSize: "14px",
  fontWeight: "600",
  color: "#374151",
};

const butonStili = (pasif) => ({
  width: "100%",
  padding: "16px",
  border: "none",
  borderRadius: "12px",
  fontSize: "16px",
  fontWeight: "700",
  color: "#ffffff",
  background: pasif ? "#94a3b8" : "linear-gradient(135deg, #10b981, #059669)",
  cursor: pasif ? "not-allowed" : "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "10px",
});

export default class KayitYeni extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adim: 1,
      yukleniyor: false,
      mesaj: null, // { tur: "hata" | "basari", metin }

      isim: "",
      soyisim: "",
      telefon: "",
      eposta: "",

      sozlesmeOnay: false,
      gizlilikOnay: false,
      pazarlamaOnay: false,

      sifre: "",
      sifreTekrar: "",
      sifreGoster: false,

      hediyeKoduAcik: false,
      hediyeKodu: "",
      tamamlandi: false,
    };
  }

  yurtDisiMi = () => {
    const t = String(this.state.telefon || "");
    return t.startsWith("+") && !t.startsWith("+90");
  };

  hata = (metin) => this.setState({ mesaj: { tur: "hata", metin }, yukleniyor: false });

  // Sunucu yanıtını tek yerde çözüyoruz: ağ hatası ile iş kuralı hatasını
  // kullanıcıya aynı dille anlatalım.
  gonder = async (yol, govde) => {
    try {
      const res = await fetch(`${API}${yol}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(govde),
      });
      const j = await res.json().catch(() => ({}));
      return { durum: res.status, j };
    } catch {
      // Ağ hatası; kullanıcıya iş kuralı hatalarıyla aynı dilde anlatılır.
      return { durum: 0, j: { mesaj: "Sunucuya ulaşılamadı. İnternet bağlantınızı kontrol edin." } };
    }
  };

  // --- Adım 1: bilgiler ---
  adim1Gecerli = () => {
    const { isim, soyisim, telefon, eposta, sozlesmeOnay, gizlilikOnay } = this.state;
    if (isim.trim().length < 2 || soyisim.trim().length < 2) return false;
    if (!telefon || telefon.length < 8) return false;
    if (this.yurtDisiMi() && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(eposta.trim())) return false;
    return sozlesmeOnay && gizlilikOnay;
  };

  // Numara ve (yurt dışında) e-posta sorunu şifre yazdırmadan söylensin.
  // Sunucu kod göndermez; yalnız kayıtlı numara / kullanımdaki e-posta bakar.
  bilgileriOnayla = async () => {
    if (!this.adim1Gecerli()) return;
    this.setState({ yukleniyor: true, mesaj: null });
    const { durum, j } = await this.gonder("/api/kayit/numara-kontrol", this.kimlikGovdesi());
    if (durum === 200 && j.basarili) {
      return this.setState({ adim: 2, yukleniyor: false, mesaj: null });
    }
    return this.hata(j.mesaj || "Numara kontrol edilemedi.");
  };

  kimlikGovdesi = () => ({
    telefon: this.state.telefon,
    eposta: this.yurtDisiMi() ? this.state.eposta.trim() : undefined,
  });

  // --- Adım 2: şifre ---  // --- Adım 3: şifre ---
  // Sunucuya ödeme isteğiyle birlikte gider; burada yalnızca denetlenir.
  sifreHatasi = () => {
    const { sifre, sifreTekrar } = this.state;
    if (sifre.length < EN_AZ_SIFRE) return `Şifre en az ${EN_AZ_SIFRE} karakter olmalı.`;
    if (sifre !== sifreTekrar) return "Şifreler aynı değil.";
    return null;
  };

  sifreyiOnayla = () => {
    const hata = this.sifreHatasi();
    if (hata) return this.hata(hata);
    this.setState({ adim: 3, mesaj: null });
  };

  // Ödeme ve hediye kodu yanıtlarında ortak: numara/e-posta sorunu varsa
  // bilgilere, şifre reddedildiyse şifre adımına dön.
  geriDon = (j, varsayilan) => {
    if (["zaten_kayitli", "eposta_kayitli", "eposta_gerekli", "gecersiz_numara"].includes(j.kod)) {
      this.setState({ adim: 1 });
      return this.hata(j.mesaj || varsayilan);
    }
    if (j.kod === "sifre_gecersiz") {
      this.setState({ adim: 2 });
      return this.hata(j.mesaj);
    }
    return this.hata(j.mesaj || varsayilan);
  };

  // --- Adım 3a: kartla ödeme ---
  odemeyeGec = async () => {
    this.setState({ yukleniyor: true, mesaj: null });
    const { durum, j } = await this.gonder("/api/kayit/odeme-baslat", {
      ...this.kimlikGovdesi(),
      isim: this.state.isim.trim(),
      soyisim: this.state.soyisim.trim(),
      sifre: this.state.sifre,
      sozlesmeOnay: this.state.sozlesmeOnay,
      gizlilikOnay: this.state.gizlilikOnay,
      pazarlamaOnay: this.state.pazarlamaOnay,
    });

    if (durum === 200 && j.basarili) {
      // Ödeme sayfası mevcut akışla aynı; tutar kuruş olarak taşınıyor.
      window.location.href = `/posnet-payment/${j.orderId}?amount=${j.tutarKurus}`;
      return;
    }
    return this.geriDon(j, "Ödeme başlatılamadı.");
  };

  // --- Adım 3b: hediye kodu ---
  hediyeKoduIleKayit = async () => {
    if (!this.state.hediyeKodu.trim()) return;
    this.setState({ yukleniyor: true, mesaj: null });

    const { durum, j } = await this.gonder("/api/kayit/hediye-kodu-ile-kayit", {
      ...this.kimlikGovdesi(),
      isim: this.state.isim.trim(),
      soyisim: this.state.soyisim.trim(),
      sifre: this.state.sifre,
      hediyeKodu: this.state.hediyeKodu,
      sozlesmeOnay: this.state.sozlesmeOnay,
      gizlilikOnay: this.state.gizlilikOnay,
      pazarlamaOnay: this.state.pazarlamaOnay,
    });

    if (durum === 200 && j.basarili) {
      return this.setState({ tamamlandi: true, yukleniyor: false, mesaj: null });
    }
    return this.geriDon(j, "Hediye kodu ile kayıt tamamlanamadı.");
  };

  // ---------------------------------------------------------------- görünüm
  mesajKutusu() {
    const { mesaj } = this.state;
    if (!mesaj) return null;
    const hataMi = mesaj.tur === "hata";
    return (
      <div
        role="alert"
        style={{
          display: "flex", alignItems: "center", gap: "10px",
          padding: "12px 16px", marginBottom: "20px", borderRadius: "12px",
          background: hataMi ? "#fef2f2" : "#dcfce7",
          border: `1px solid ${hataMi ? "#fca5a5" : "#10b981"}`,
          color: hataMi ? "#991b1b" : "#065f46",
          fontSize: "14px",
        }}
      >
        {hataMi ? <AlertCircle size={18} /> : <CheckCircle size={18} />}
        <span>{mesaj.metin}</span>
      </div>
    );
  }

  adimGostergesi() {
    const { adim } = this.state;
    const adimlar = ["Bilgiler", "Şifre", "Ödeme"];
    return (
      <div style={{ display: "flex", gap: "8px", marginBottom: "28px" }}>
        {adimlar.map((ad, i) => {
          const no = i + 1;
          const aktif = adim >= no;
          return (
            <div key={ad} style={{ flex: 1 }}>
              <div style={{ height: "4px", borderRadius: "2px", background: aktif ? "#10b981" : "#e2e8f0" }} />
              <div style={{ marginTop: "8px", fontSize: "12px", fontWeight: aktif ? 700 : 500, color: aktif ? "#059669" : "#94a3b8" }}>
                {no}. {ad}
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  onayKutusu(alan, icerik) {
    return (
      <label style={{ display: "flex", alignItems: "flex-start", gap: "10px", marginBottom: "12px", cursor: "pointer", fontSize: "13px", color: "#475569", lineHeight: 1.5 }}>
        <input
          type="checkbox"
          checked={this.state[alan]}
          onChange={(e) => this.setState({ [alan]: e.target.checked })}
          style={{ marginTop: "3px", width: "18px", height: "18px", accentColor: "#10b981", flexShrink: 0 }}
        />
        <span>{icerik}</span>
      </label>
    );
  }

  render() {
    const { adim, yukleniyor, tamamlandi } = this.state;
    const { birimUcretTl } = this.props;

    if (tamamlandi) {
      return (
        <div style={{ textAlign: "center", padding: "20px 0" }}>
          <CheckCircle size={56} color="#10b981" />
          <h2 style={{ margin: "18px 0 10px", fontSize: "22px", color: "#065f46" }}>Üyeliğiniz hazır</h2>
          <p style={{ color: "#475569", fontSize: "15px", lineHeight: 1.6, marginBottom: "24px" }}>
            UniversalTeam uygulamasını indirip <strong>telefon numaranız ve şifrenizle</strong> giriş yapabilirsiniz.
          </p>
          <div style={{ marginBottom: "18px" }}>
            <UygulamayaGec />
          </div>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", padding: "14px", background: "#f0fdf4", border: "1px solid #10b981", borderRadius: "12px", color: "#065f46", fontSize: "14px" }}>
            <Smartphone size={18} />
            <span>Profil bilgilerinizi uygulamada tamamlayacaksınız.</span>
          </div>
        </div>
      );
    }

    return (
      <div>
        {this.adimGostergesi()}
        {this.mesajKutusu()}

        {/* ---------------- Adım 1: bilgiler ---------------- */}
        {adim === 1 && (
          <form onSubmit={(e) => { e.preventDefault(); this.bilgileriOnayla(); }}>
            <div className="register-form-row">
              <div style={{ flex: 1 }}>
                <label style={etiketStili}>Ad *</label>
                <input
                  type="text" value={this.state.isim} required placeholder="Adınız"
                  onChange={(e) => this.setState({ isim: e.target.value })}
                  style={kutuStili}
                  onFocus={(e) => (e.target.style.borderColor = "#10b981")}
                  onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}
                />
              </div>
              <div style={{ flex: 1 }}>
                <label style={etiketStili}>Soyad *</label>
                <input
                  type="text" value={this.state.soyisim} required placeholder="Soyadınız"
                  onChange={(e) => this.setState({ soyisim: e.target.value })}
                  style={kutuStili}
                  onFocus={(e) => (e.target.style.borderColor = "#10b981")}
                  onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}
                />
              </div>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label style={etiketStili}>Telefon *</label>
              <PhoneInput
                international
                defaultCountry="TR"
                labels={trLabels}
                value={this.state.telefon}
                onChange={(v) => this.setState({ telefon: v || "", mesaj: null })}
                placeholder="Telefon numaranız"
              />
              <p style={{ margin: "8px 0 0", fontSize: "12px", color: "#64748b" }}>
                {this.yurtDisiMi()
                  ? "Uygulamaya bu numara ve belirleyeceğiniz şifreyle gireceksiniz."
                  : "Uygulamaya bu numara ve belirleyeceğiniz şifreyle gireceksiniz. Numaranız ilk girişte SMS ile doğrulanır."}
              </p>
            </div>

            {/* Yurt dışı numarasına SMS güvenilir gitmediği için hesap e-postayla doğrulanır */}
            {this.yurtDisiMi() && (
              <div style={{ marginBottom: "20px" }}>
                <label style={etiketStili}>E-posta *</label>
                <div style={{ position: "relative" }}>
                  <Mail size={20} style={{ position: "absolute", left: "18px", top: "50%", transform: "translateY(-50%)", color: "#9ca3af" }} />
                  <input
                    type="email" value={this.state.eposta} placeholder="ornek@email.com"
                    onChange={(e) => this.setState({ eposta: e.target.value })}
                    style={{ ...kutuStili, paddingLeft: "50px" }}
                    onFocus={(e) => (e.target.style.borderColor = "#10b981")}
                    onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}
                  />
                </div>
                <p style={{ margin: "8px 0 0", fontSize: "12px", color: "#64748b" }}>
                  Hesabınız ilk girişte bu adrese gönderilecek kodla doğrulanır.
                </p>
              </div>
            )}

            <div style={{ padding: "16px", background: "#f8fafc", borderRadius: "12px", marginBottom: "20px" }}>
              {this.onayKutusu("sozlesmeOnay", <>
                <a href="/gizlilik_politikasi/uyelik_satis_sozlesmesi" target="_blank" rel="noreferrer" style={{ color: "#059669", fontWeight: 600 }}>Üyelik sözleşmesini</a> okudum, kabul ediyorum. *
              </>)}
              {this.onayKutusu("gizlilikOnay", <>
                <a href="/gizlilik_politikasi" target="_blank" rel="noreferrer" style={{ color: "#059669", fontWeight: 600 }}>Gizlilik politikasını</a> okudum, kabul ediyorum. *
              </>)}
              {this.onayKutusu("pazarlamaOnay", "Kampanya ve duyuru bildirimleri almak istiyorum. (isteğe bağlı)")}
            </div>

            <button type="submit" disabled={yukleniyor || !this.adim1Gecerli()} style={butonStili(yukleniyor || !this.adim1Gecerli())}>
              {yukleniyor ? "Kontrol ediliyor…" : <>Devam <ArrowRight size={18} /></>}
            </button>
          </form>
        )}

        {/* ---------------- Adım 2: şifre ---------------- */}
        {adim === 2 && (
          <form onSubmit={(e) => { e.preventDefault(); this.sifreyiOnayla(); }}>
            <p style={{ color: "#475569", fontSize: "15px", lineHeight: 1.6, marginBottom: "20px" }}>
              Uygulamaya giriş şifrenizi belirleyin.
            </p>

            {[
              ["sifre", "Şifre *", `En az ${EN_AZ_SIFRE} karakter`, "new-password"],
              ["sifreTekrar", "Şifre (tekrar) *", "Şifrenizi tekrar yazın", "new-password"],
            ].map(([alan, etiket, ipucu, otomatik]) => (
              <div key={alan} style={{ marginBottom: "20px" }}>
                <label style={etiketStili}>{etiket}</label>
                <div style={{ position: "relative" }}>
                  <Lock size={20} style={{ position: "absolute", left: "18px", top: "50%", transform: "translateY(-50%)", color: "#9ca3af" }} />
                  <input
                    type={this.state.sifreGoster ? "text" : "password"}
                    autoComplete={otomatik}
                    value={this.state[alan]} placeholder={ipucu}
                    onChange={(e) => this.setState({ [alan]: e.target.value, mesaj: null })}
                    style={{ ...kutuStili, paddingLeft: "50px", paddingRight: "50px" }}
                    onFocus={(e) => (e.target.style.borderColor = "#10b981")}
                    onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}
                  />
                  {alan === "sifre" && (
                    <button type="button" onClick={() => this.setState((s) => ({ sifreGoster: !s.sifreGoster }))}
                      aria-label={this.state.sifreGoster ? "Şifreyi gizle" : "Şifreyi göster"}
                      style={{ position: "absolute", right: "14px", top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "#64748b", padding: 0, display: "flex" }}>
                      {this.state.sifreGoster ? <EyeOff size={20} /> : <Eye size={20} />}
                    </button>
                  )}
                </div>
              </div>
            ))}

            <p style={{ margin: "-8px 0 20px", fontSize: "12px", color: "#64748b" }}>
              Uygulamaya telefon numaranız ve bu şifreyle gireceksiniz.
            </p>

            <button type="submit" disabled={!this.state.sifre || !this.state.sifreTekrar} style={butonStili(!this.state.sifre || !this.state.sifreTekrar)}>
              Devam <ArrowRight size={18} />
            </button>

            <button type="button" onClick={() => this.setState({ adim: 1, mesaj: null })}
              style={{ background: "none", border: "none", color: "#64748b", cursor: "pointer", display: "flex", alignItems: "center", gap: "6px", fontSize: "14px", marginTop: "18px", padding: 0 }}>
              <ArrowLeft size={16} /> Bilgilere dön
            </button>
          </form>
        )}

        {/* ---------------- Adım 3: ödeme ---------------- */}
        {adim === 3 && (
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px", padding: "14px", background: "#f0fdf4", border: "1px solid #10b981", borderRadius: "12px", color: "#065f46", fontSize: "14px", marginBottom: "24px" }}>
              <CheckCircle size={18} />
              <span>Şifreniz belirlendi. Son adım: üyelik ödemesi.</span>
            </div>

            {!this.state.hediyeKoduAcik && (
              <>
                <button type="button" disabled={yukleniyor || birimUcretTl === null} onClick={this.odemeyeGec}
                  style={butonStili(yukleniyor || birimUcretTl === null)}>
                  {yukleniyor ? "Hazırlanıyor…" : (
                    <><CreditCard size={18} /> Kartla öde{birimUcretTl !== null ? ` (${Number(birimUcretTl).toLocaleString("tr-TR")}₺)` : ""}</>
                  )}
                </button>
                {birimUcretTl === null && (
                  <p style={{ margin: "10px 0 0", fontSize: "13px", color: "#94a3b8", textAlign: "center" }}>
                    Üyelik ücreti alınıyor…
                  </p>
                )}
                <button type="button" onClick={() => this.setState({ hediyeKoduAcik: true, mesaj: null })}
                  style={{ width: "100%", marginTop: "14px", padding: "14px", background: "#ffffff", border: "2px solid #e2e8f0", borderRadius: "12px", color: "#475569", fontSize: "15px", fontWeight: 600, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                  <Tag size={18} /> Hediye kodum var
                </button>
              </>
            )}

            {this.state.hediyeKoduAcik && (
              <form onSubmit={(e) => { e.preventDefault(); this.hediyeKoduIleKayit(); }}>
                <label style={etiketStili}>Hediye kodu</label>
                <input
                  type="text" value={this.state.hediyeKodu} placeholder="Hediye kodunuzu girin"
                  onChange={(e) => this.setState({ hediyeKodu: e.target.value.toUpperCase() })}
                  style={{ ...kutuStili, letterSpacing: "2px", fontWeight: 600, marginBottom: "16px" }}
                  onFocus={(e) => (e.target.style.borderColor = "#10b981")}
                  onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}
                />
                <button type="submit" disabled={yukleniyor || !this.state.hediyeKodu.trim()} style={butonStili(yukleniyor || !this.state.hediyeKodu.trim())}>
                  {yukleniyor ? "Kontrol ediliyor…" : <><UserPlus size={18} /> Hediye kodu ile üye ol</>}
                </button>
                <button type="button" onClick={() => this.setState({ hediyeKoduAcik: false, mesaj: null })}
                  style={{ background: "none", border: "none", color: "#64748b", cursor: "pointer", display: "flex", alignItems: "center", gap: "6px", fontSize: "14px", marginTop: "18px", padding: 0 }}>
                  <ArrowLeft size={16} /> Kartla ödemeye dön
                </button>
              </form>
            )}

            <div style={{ display: "flex", alignItems: "flex-start", gap: "10px", marginTop: "24px", padding: "14px", background: "#f8fafc", borderRadius: "12px", color: "#64748b", fontSize: "13px", lineHeight: 1.6 }}>
              <Phone size={16} style={{ flexShrink: 0, marginTop: "2px" }} />
              <span>
                Ödemeden sonra uygulamaya <strong>telefon numaranız ve şifrenizle</strong> gireceksiniz.
                Kalan profil bilgilerinizi uygulama içinde tamamlayacaksınız.
              </span>
            </div>
          </div>
        )}
      </div>
    );
  }
}

KayitYeni.propTypes = {
  // Üyelik ücreti sunucudan okunuyor; gelene kadar null olur ve ödeme kapalı kalır.
  birimUcretTl: PropTypes.number,
};
